import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/pages/halloween';
import Logotype from './logotype';
import TimerSvg from './timer_svg';
import {useNavigate} from 'react-router-dom';
import Timer from '../timer';

export default () => {
    const navigate = useNavigate(),
          {halloween} = useSelector(Selector);

    return (
        <div className="main">
            <div className="close" onClick={e => navigate('/')}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_166_7969)">
                        <path d="M0 14L14 0" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14 14L0 0" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_166_7969">
                            <rect width="14" height="14" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>

            <Logotype />

            <div className="timer">
                <div className="time">
                    <Timer timeoutKey={"main-halloween"} timestamp={halloween.timestamp} />
                </div>
                <TimerSvg />
            </div>
            <div className="text">Get prizes for your activity and try your luck in the main prize draw! The main prize draw will take place on November 25!</div>
        </div>
    )
}